(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atg-battery-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atg-battery-extras')) {
    customElements.define('atg-battery-extras', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.abortController.signal });
        } else {
          this.initialize();
        }
      }
      disconnectedCallback() { this.abortController?.abort(); }
      initialize() {
        this.form = this.closest('form');
        if (!this.form) return;
        this.buttonLabel = this.form.querySelector('[type="submit"] > span');
        if (!this.buttonLabel) return;
        this.querySelector('fieldset').disabled = false;
        const scope = this.closest('product-info') || this.form;
        scope.addEventListener('change', () => this.update(), { signal: this.abortController.signal });
        scope.addEventListener('input', (event) => {
          if (event.target.name === 'quantity') this.update();
        }, { signal: this.abortController.signal });
        this.update();
      }
      getItems() {
        return Array.from(this.querySelectorAll('input[data-addon-id]:checked:not(:disabled)')).map(input => ({ id: input.dataset.addonId, quantity: 1 }));
      }
      update() {
        if (!this.form || !this.buttonLabel) return;
        const selected = Array.from(this.querySelectorAll('input[data-addon-id]:checked:not(:disabled)'));
        const quantity = Math.max(1, Number(new FormData(this.form).get('quantity')) || 1);
        const total = Number(this.dataset.batteryPrice) * quantity + selected.reduce((sum, input) => sum + Number(input.dataset.price), 0);
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD', currencyDisplay: 'narrowSymbol' }).format(total / 100);
        this.querySelector('[data-extras-summary]').textContent = selected.length ? this.dataset.selectedLabel.replace('[count]', selected.length) : this.dataset.emptyLabel;
        this.querySelector('.atg-extras__total').hidden = selected.length === 0;
        this.querySelector('[data-extras-total]').textContent = formatted;
        if (!this.form.querySelector('[type="submit"]').disabled) this.buttonLabel.textContent = this.dataset.buyLabel + ' — ' + formatted;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
